import { RichText } from "@faire/web/builder/registerBuilderComponents/TypeParser/types";
import { IBuilderComponent } from "@faire/web/builder/registerBuilderComponents/types";

import { AccordionProps } from "./Accordion";

type Content = {
  question: string;
  answer: RichText;
};
export interface IAdditionalProps {
  contents: Content[];
}

export const BuilderConfig: IBuilderComponent<
  AccordionProps,
  IAdditionalProps
> = {
  name: "Accordion",
  relativePath: "./Accordion.tsx",
  propDefinition: {
    name: "AccordionProps",
    path: "./Accordion.tsx",
  },
  transformations: {
    "data-test-id": null,
    initiallyOpenIndex: null,
    useSerif: null,
    items: (props) =>
      props.contents.map(({ question, answer }) => {
        return { question, answer, fromBuilder: true };
      }) ?? [{ question: "Question", answer: "Answer", fromBuilder: true }],
    onItemClick: null,
  },
  defaultValues: {
    title: "You may be wondering",
  },
  localizedFields: ["title"],
};
